module.exports = __webpack_public_path__ + "static/media/expo.6bec4d5e.png";